import 'core-js/stable'
import Vue from 'vue'
import CoreuiVue from '@coreui/vue'
import App from './App'
import { router } from "./_helpers";
// import router from './router/index'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import selectPicker from 'vue-selectpicker'
Vue.use(selectPicker)
import vSelect from "vue-select";
import firebase from 'firebase';
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'




const firebaseConfig = {
  apiKey: "AIzaSyCoJ9-4c5OF_Zrlqu657vyvXe2OY7HPo8o",
  authDomain: "token-geomine.firebaseapp.com",
  databaseURL: "https://token-geomine-default-rtdb.firebaseio.com",
  projectId: "token-geomine",
  storageBucket: "token-geomine.appspot.com",
  messagingSenderId: "201830283754",
  appId: "1:201830283754:web:1c7e30646a8520509d9a93",
  measurementId: "G-N39Q3X4NY5"
};



// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyAMFqfBHI-oj1k3F43A61sgV2HRthrMutw",
//   authDomain: "token-geomine.firebaseapp.com",
//   projectId: "token-geomine",
//   storageBucket: "token-geomine.appspot.com",
//   messagingSenderId: "201830283754",
//   appId: "1:201830283754:web:38ef1fdb8e9d14ca9d9a93",
//   measurementId: "G-GWGXGWNWBQ"
// };

// firebase//
firebase.initializeApp(firebaseConfig);

Vue.component("v-select", vSelect);
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyD9eV2-gCz_Xe-OvxlqUt9WQ2q23_bB4YY",
    libraries: "places"
  }
});

import VueSweetalert2 from 'vue-sweetalert2';

Vue.use(VueSweetalert2);
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)

let app;
firebase.auth().onAuthStateChanged(user => {
  if (!app) {
    new Vue({
      el: '#app',
      router,
      store,
      //CIcon component documentation: https://coreui.io/vue/docs/components/icon
      icons,
      template: '<App/>',
      components: {
        App,
        // backup
      }
    })
  }
})

// new Vue({
//   el: '#app',
//   router,
//   store,
//   //CIcon component documentation: https://coreui.io/vue/docs/components/icon
//   icons,
//   template: '<App/>',
//   components: {
//     App
//   }
// })
